export default __webpack_public_path__ + "static/media/tarjeta-contacto.7826e670.jpg";